import React from 'react';
import {Page, Button, Icon} from "Components";
import { useDataContext } from "UIDataHandler";
import { HandThumbsUpFill } from "react-bootstrap-icons";
import IconTypeEnum from "Enum/IconTypeEnum";
import { goToPCareMenu } from "KeyboardEventHelper";

const ThankYouPage = ({}) => {
    const { isKiosk, goToNextQuestion, controllerMode } = useDataContext();

    React.useEffect(() => {
        if (isKiosk) {
            setTimeout(() => {
                window.location.reload(true);
            }, 60000);
        }
        if (controllerMode) {
            setTimeout(() => {
                goToPCareMenu();
            }, 3000);
        }
    }, [])

    return <Page className={`flex flex-col gap-[55px] items-center justify-center text-center color1-text`}>
        <h1 className={`text-3xl md:text-5xl flex-none w-full m-auto`}>{`Thank You For Your Feedback!`}</h1>
        {isKiosk
            ? <Button onClick={goToNextQuestion} type={'large'} className={`m-auto w-10/12 md:w-1/3`}>Home</Button>
            : <HandThumbsUpFill className={`m-auto`} height={'45px'} width={'45px'} />
        }
        { controllerMode && <h2 className={`items-center md:flex md:flex-row md:gap-[10px]`} onClick={() => goToPCareMenu()}>Press <Icon type={IconTypeEnum.MENU} size={25} /> to Quit</h2>}
    </Page>
};

export default ThankYouPage;
